<template>
	<div class="distributionUser">
		<div style="background:#ecf2f7;margin:10px;height:50px;line-height:50px;font-size:18px;text-align:left;padding:0px 15px">收益明细</div>
		<el-table :data="tableData" style="width: 100%">
			<el-table-column prop="order_id" label="订单编号" align="center"></el-table-column>
			<el-table-column label="商品名称" align="center" prop="goods_name"></el-table-column>
			<el-table-column prop="pay_price" label="订单金额" align="center"></el-table-column>
			<el-table-column prop="commission" label="佣金金额" align="center"></el-table-column>
			<el-table-column prop="status" label="状态" align="center">
			<template slot-scope="scope">
					<span>{{scope.status==1?'订单取消或退款':'订单完成'}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="add_time" label="下单时间" align="center"></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="primary" size="small" @click="detail(scope.row)">订单详情</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { revenueBreakdown } from '../../service/distribution';
	export default {
		name: 'distributionUser',
		data() {
			return {
				tableData: [],
				pageOption: {
					total: 0,
					page: 1,
					page_size: 20,
				},
			}
		},
		created() {
			this.getList();
		},
		methods: {
			getList() {
				revenueBreakdown({ user_id: this.$route.query.data}).then(res=>{
					this.pageOption.total = res.totalRow;
					this.pageOption.page = res.page;
					this.tableData = res.list;
				})
			},
			pageChange(index) {
				this.pageOption.page = index;
				this.getList();
			},
			detail(data){
				this.$router.push({path:'/orderDetail',query:{data:data.order_id}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.distributionUser{
		background-color: white;
	}
	.baseInfo {
		display: flex;
		align-items: center;
		.content {
			margin-left: 20px;
			display: flex;
			flex-direction: column;
		}
	}
</style>